import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BuilderContainer from '@/components/Builder/BuilderContainer.vue';
import { setupVueI18n } from '@/plugin/vue-i18n';
import { UIContentWrap } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import { provide } from 'vue';
import '../index.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BuilderPage',
    props: {
        route: Object,
        router: Object,
        emitter: Object,
        user: Object,
        tokenId: String,
        locale: String,
        companyInfo: Object,
        locationInfo: Object,
    },
    setup(__props) {
        const props = __props;
        setupVueI18n();
        // inject current route
        provide('route', props.route);
        provide('router', props.router);
        provide('emitter', props.emitter);
        provide('user', props.user);
        provide('tokenId', props.tokenId);
        provide('locale', props.locale);
        provide('companyInfo', props.companyInfo);
        provide('locationInfo', props.locationInfo);
        /* DON't write any direct logics here because if we use
        composition here it won't be able to access providers
        */
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), {
                class: "bg-white h-screen",
                "full-screen": "",
                locale: props.locale
            }, {
                default: _withCtx(() => [
                    _createVNode(BuilderContainer)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["locale"]));
        };
    }
});
